/**
 * Parse google OAuth token
 * @param idToken
 * @returns {{}|any}
 */
export function parseIdToken(idToken) {
    try {
        const base64Url = idToken.split('.')[1];
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        const jsonPayload = decodeURIComponent(
            atob(base64)
                .split('')
                .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
                .join('')
        );
        return JSON.parse(jsonPayload); // { email, name, given_name, family_name, picture, ... }
    } catch (e) {
        console.error('Failed to parse ID token', e);
        return {};
    }
}



// WEBPACK FOOTER //
// ./src/common/helper/index.js